var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupUnderReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 56.875C45.9619 56.875 56.875 45.9619 56.875 32.5C56.875 19.0381 45.9619 8.125 32.5 8.125C19.0381 8.125 8.125 19.0381 8.125 32.5C8.125 45.9619 19.0381 56.875 32.5 56.875Z",
    stroke: "#0D6832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3594 24.4375C25.0076 24.4375 26.3438 25.7737 26.3438 27.4219C26.3438 29.0701 25.0076 30.4062 23.3594 30.4062C21.7112 30.4062 20.375 29.0701 20.375 27.4219C20.375 25.7737 21.7112 24.4375 23.3594 24.4375Z",
    fill: "#0D6832",
    stroke: "#0D6832",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6406 24.4375C43.2888 24.4375 44.625 25.7737 44.625 27.4219C44.625 29.0701 43.2888 30.4062 41.6406 30.4062C39.9924 30.4062 38.6562 29.0701 38.6562 27.4219C38.6562 25.7737 39.9924 24.4375 41.6406 24.4375Z",
    fill: "#0D6832",
    stroke: "#0D6832",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6562 38.5938C40.5488 42.2373 37.0119 44.6875 32.5 44.6875C27.9881 44.6875 24.4512 42.2373 22.3438 38.5938",
    stroke: "#0D6832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupUnderReviewIcon);
export default __webpack_public_path__ + "static/media/SignupUnderReviewIcon.a1005ff625fa731d11a15792a8cba52a.svg";
export { ForwardRef as ReactComponent };